export interface Chapter {
  no: number;
  title: string;
  updated: string;
}

export interface Comic {
  id: string;
  title: string;
  cover: string;
  category: string;
  tags: string[];
  score: number;
  chapters: number;
  status: string;
  views: string;
  author: string;
  desc: string;
  detail: string;
  updates: string;
  chapterList: Chapter[];
}

export const categories = [
  "全部",
  "科幻",
  "恋爱",
  "奇幻",
  "日常",
  "悬疑",
  "冒险",
  "古风",
  "治愈",
];

export const comics: Comic[] = [
  {
    id: "xingqiong-zhiyue",
    title: "星穹之约",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20young%20girl%20with%20flowing%20silver%20hair%20standing%20under%20a%20vast%20cosmic%20starry%20sky%20with%20a%20glowing%20golden%20nebula%20and%20falling%20stars%2C%20romance%20science%20fiction%20manga%20cover%2C%20warm%20cinematic%20lighting%2C%20vibrant%20detail%20character%20art%2C%20portrait%20composition&width=600&height=800&seq=cover-xingqiong-1&orientation=portrait",
    category: "科幻",
    tags: ["星际", "治愈", "青春"],
    score: 9.4,
    chapters: 128,
    status: "连载中",
    views: "286万",
    author: "阿澈",
    desc: "少女蓝星收到来自遥远星系的讯号，一段跨越光年的约定就此展开。",
    detail:
      "在未来纪元，地球少年少女通过神秘的「星轨仪」连接上银河另一端的生命体。本作以温柔的笔触描绘两个世界的少年少女如何在漫长的星际距离中互相守候、并肩成长。每一话都像一封寄往星海的情书，充满对未知宇宙的浪漫想象与对青春约定的珍视。",
    updates: "更新至 第128话",
    chapterList: [
      { no: 128, title: "银河的尽头", updated: "今日 10:20" },
      { no: 127, title: "迟到的回信", updated: "昨日 21:05" },
      { no: 126, title: "星轨交错", updated: "08-15" },
      { no: 125, title: "遥远的拥抱", updated: "08-12" },
      { no: 124, title: "约定的重量", updated: "08-09" },
    ],
  },
  {
    id: "xiangsu-xueyuan",
    title: "像素学院",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20cheerful%20teenage%20students%20in%20colorful%20school%20uniforms%20on%20a%20futuristic%20academy%20campus%20with%20floating%20holographic%20screens%20and%20bright%20sunlight%2C%20slice%20of%20life%20manga%20cover%2C%20warm%20cheerful%20color%20palette%2C%20portrait%20composition&width=600&height=800&seq=cover-xiangsu-2&orientation=portrait",
    category: "日常",
    tags: ["校园", "轻松", "搞笑"],
    score: 8.9,
    chapters: 96,
    status: "连载中",
    views: "172万",
    author: "小芝麻",
    desc: "全息校园里的爆笑日常，五个怪同学与一个普通人的欢乐冒险。",
    detail:
      "像素学院是一座由人工智能管理的未来校园，这里的学生可以「吃掉」知识点，还能把烦恼装进像素罐子里。主角凌一进入学院后，遇见了会说话的课本、半夜巡逻的机器人宿管，以及一群脑回路清奇的怪同学。故事节奏轻快，笑点密集，是适合放松心情的下饭漫画。",
    updates: "更新至 第96话",
    chapterList: [
      { no: 96, title: "考试大作战", updated: "今日 09:40" },
      { no: 95, title: "宿管机器人的秘密", updated: "昨日 20:15" },
      { no: 94, title: "像素运动会", updated: "08-14" },
      { no: 93, title: "吃掉数学公式", updated: "08-11" },
      { no: 92, title: "新同学报到", updated: "08-08" },
    ],
  },
  {
    id: "shenhai-youchai",
    title: "深海邮差",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20young%20mail%20carrier%20boy%20in%20a%20glass%20diving%20helmet%20delivering%20letters%20through%20a%20glowing%20underwater%20city%20with%20colorful%20fish%20and%20coral%2C%20fantasy%20manga%20cover%2C%20warm%20gold%20lighting%2C%20portrait%20composition&width=600&height=800&seq=cover-shenhai-3&orientation=portrait",
    category: "奇幻",
    tags: ["海洋", "冒险", "治愈"],
    score: 9.1,
    chapters: 74,
    status: "连载中",
    views: "143万",
    author: "海盐泡泡",
    desc: "潜入深海送信的少年，每一封信背后都有一个温暖的海底故事。",
    detail:
      "在沉没的都市里，有一座只在月圆之夜开放的海底邮局。少年阿浪是这里唯一的邮差，他驾驶着玻璃潜水艇，把陆地上的人写给海底精灵、失落之城的信一一送达。作品画面唯美，海潮般的配色与细腻的情感描写让人沉浸，是近期口碑极高的治愈系奇幻佳作。",
    updates: "更新至 第74话",
    chapterList: [
      { no: 74, title: "月圆之约", updated: "今日 08:55" },
      { no: 73, title: "沉船里的钢琴", updated: "昨日 19:30" },
      { no: 72, title: "寄往百年前", updated: "08-13" },
      { no: 71, title: "会唱歌的海螺", updated: "08-10" },
      { no: 70, title: "邮差的新航线", updated: "08-07" },
    ],
  },
  {
    id: "yueguang-bianlidian",
    title: "月光便利店",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cozy%20convenience%20store%20glowing%20warmly%20at%20night%20with%20a%20friendly%20cat%20shopkeeper%20and%20shelves%20of%20goods%2C%20healing%20slice%20of%20life%20manga%20cover%2C%20soft%20amber%20lamp%20lighting%2C%20nostalgic%20atmosphere%2C%20portrait%20composition&width=600&height=800&seq=cover-yueguang-4&orientation=portrait",
    category: "治愈",
    tags: ["日常", "暖心", "深夜"],
    score: 9.0,
    chapters: 88,
    status: "已完结",
    views: "219万",
    author: "晚风故事",
    desc: "只在午夜开张的便利店，用一碗关东煮抚慰每个夜归人。",
    detail:
      "城市角落有一家只在午夜营业的便利店，店主是一只戴着围裙的橘猫，货架上摆着能「尝到回忆」的零食。每一个深夜光临的客人，都在这里找到属于自己的味道与答案。漫画由一个个独立的小故事组成，温润治愈，适合睡前安静地读上一话。",
    updates: "已完结 共88话",
    chapterList: [
      { no: 88, title: "打烊前的关东煮", updated: "08-10" },
      { no: 87, title: "凌晨三点的客人", updated: "08-06" },
      { no: 86, title: "遗失的伞", updated: "08-02" },
      { no: 85, title: "会唱歌的微波炉", updated: "07-29" },
      { no: 84, title: "猫店长的日记", updated: "07-25" },
    ],
  },
  {
    id: "nihong-zhentanshe",
    title: "霓虹侦探社",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20detective%20duo%20in%20long%20trench%20coats%20standing%20in%20a%20rainy%20city%20street%20at%20night%20with%20warm%20orange%20and%20red%20neon%20signs%20glowing%2C%20mystery%20manga%20cover%2C%20moody%20cinematic%20atmosphere%2C%20portrait%20composition&width=600&height=800&seq=cover-nihong-5&orientation=portrait",
    category: "悬疑",
    tags: ["推理", "都市", "反转"],
    score: 9.3,
    chapters: 102,
    status: "连载中",
    views: "198万",
    author: "黑猫探长",
    desc: "一间开在霓虹雨夜里的侦探社，专接都市里的奇案怪谈。",
    detail:
      "繁华都市的霓虹下，藏着无数不为人知的秘密。侦探社只有两位成员：沉默寡言的老探长，和能看到「谎言颜色」的新人助手。两人在雨夜的街头接下一桩桩离奇案件，每个案件都环环相扣，结尾反转不断。氛围感极强的悬疑佳作，追更体验极佳。",
    updates: "更新至 第102话",
    chapterList: [
      { no: 102, title: "霓虹下的真凶", updated: "今日 07:20" },
      { no: 101, title: "消失的证词", updated: "昨日 22:00" },
      { no: 100, title: "第七个委托人", updated: "08-14" },
      { no: 99, title: "谎言的颜色", updated: "08-11" },
      { no: 98, title: "雨夜的脚步声", updated: "08-08" },
    ],
  },
  {
    id: "yunduan-huayuan",
    title: "云端花园",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20gardener%20girl%20tending%20floating%20flowers%20in%20a%20sky%20garden%20above%20soft%20clouds%20with%20a%20small%20wooden%20airship%2C%20fantasy%20healing%20manga%20cover%2C%20soft%20golden%20sunlight%2C%20portrait%20composition&width=600&height=800&seq=cover-yunduan-6&orientation=portrait",
    category: "治愈",
    tags: ["空中花园", "成长", "清新"],
    score: 8.8,
    chapters: 66,
    status: "连载中",
    views: "121万",
    author: "云朵糖",
    desc: "漂浮在云海之上的花园，种下的是每个人遗落的愿望。",
    detail:
      "在云层之上，有一座靠愿望浇灌的花园。花匠少女小雾每天驾驶小飞艇，采集人间飘上来的愿望，把它们种成会发光的花。某天她发现一朵开不出花的黑色花苞，它的主人是谁？故事清新治愈，画风明亮，适合想找一份宁静的读者。",
    updates: "更新至 第66话",
    chapterList: [
      { no: 66, title: "开不出花的花苞", updated: "今日 06:30" },
      { no: 65, title: "云海里的鲸", updated: "昨日 18:10" },
      { no: 64, title: "雨天的种子", updated: "08-12" },
      { no: 63, title: "飞艇维修日", updated: "08-09" },
      { no: 62, title: "愿望的形状", updated: "08-06" },
    ],
  },
  {
    id: "jijia-shaoniantuan",
    title: "机甲少年团",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20team%20of%20teenage%20pilots%20standing%20in%20front%20of%20colorful%20mecha%20robots%20on%20a%20battlefield%20at%20sunset%2C%20action%20adventure%20manga%20cover%2C%20warm%20orange%20sunset%20lighting%2C%20dynamic%20composition%2C%20portrait&width=600&height=800&seq=cover-jijia-7&orientation=portrait",
    category: "冒险",
    tags: ["机甲", "热血", "少年"],
    score: 9.2,
    chapters: 140,
    status: "连载中",
    views: "305万",
    author: "钢铁星尘",
    desc: "五个少年驾驶机甲守护家园，热血与羁绊的成长物语。",
    detail:
      "能源枯竭的未来，人类依靠巨型机甲「星轨」对抗来自深空的威胁。性格迥异的五名少年被选入少年团，从互不信任到并肩作战。作品战斗场面张力十足，机甲设计精细，同时细腻刻画了少年们的成长与羁绊，是当下人气居高不下的热血连载。",
    updates: "更新至 第140话",
    chapterList: [
      { no: 140, title: "决战之前", updated: "今日 05:10" },
      { no: 139, title: "星轨全开", updated: "昨日 23:45" },
      { no: 138, title: "第五位队友", updated: "08-15" },
      { no: 137, title: "月光下的机甲", updated: "08-12" },
      { no: 136, title: "第一次出击", updated: "08-09" },
    ],
  },
  {
    id: "guwu-kezhan",
    title: "古物客栈",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20kind%20innkeeper%20girl%20among%20glowing%20ancient%20artifacts%20and%20red%20lanterns%20in%20a%20traditional%20wooden%20inn%2C%20traditional%20fantasy%20manga%20cover%2C%20warm%20crimson%20and%20gold%20lighting%2C%20portrait%20composition&width=600&height=800&seq=cover-guowu-8&orientation=portrait",
    category: "古风",
    tags: ["古风", "仙侠", "甜宠"],
    score: 8.7,
    chapters: 81,
    status: "连载中",
    views: "156万",
    author: "灯笼花",
    desc: "一间收留奇物与过客的客栈，藏着许多古老而温柔的传说。",
    detail:
      "山脚下有一间看似寻常的客栈，老板娘却是能听懂器物低语的奇人。夜半打烊后，古镜、折扇、玉佩会开口讲述它们主人的往事。作品古风韵味浓厚，配色素雅温暖，把一个个器物背后的悲欢离合娓娓道来，甜中带泪，余韵悠长。",
    updates: "更新至 第81话",
    chapterList: [
      { no: 81, title: "会哭的古镜", updated: "今日 04:20" },
      { no: 80, title: "折扇的故事", updated: "昨日 21:40" },
      { no: 79, title: "玉佩的执念", updated: "08-13" },
      { no: 78, title: "灯下谈天", updated: "08-10" },
      { no: 77, title: "神秘的过客", updated: "08-07" },
    ],
  },
  {
    id: "mitang-hongbeiwu",
    title: "蜜糖烘焙屋",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cheerful%20baker%20girl%20decorating%20a%20colorful%20layer%20cake%20in%20a%20warm%20bakery%20full%20of%20fresh%20pastries%20and%20cream%2C%20slice%20of%20life%20manga%20cover%2C%20soft%20warm%20pink%20and%20cream%20lighting%2C%20portrait%20composition&width=600&height=800&seq=cover-mitang-9&orientation=portrait",
    category: "日常",
    tags: ["美食", "恋爱", "轻松"],
    score: 8.6,
    chapters: 58,
    status: "已完结",
    views: "98万",
    author: "奶油泡芙",
    desc: "甜品店里的恋爱日常，每一份点心都藏着小心思。",
    detail:
      "开在街角的面包店「蜜糖烘焙屋」，主厨少女和她的青梅竹马一起经营。甜点的香气里，藏着说不出口的心意与甜甜的日常。作品画风软糯可爱，美食画面诱人，恋爱线自然治愈，适合喜欢轻松甜宠故事的读者一口气看完。",
    updates: "已完结 共58话",
    chapterList: [
      { no: 58, title: "最甜的告白", updated: "08-05" },
      { no: 57, title: "生日蛋糕的秘密", updated: "08-01" },
      { no: 56, title: "下雨天的可丽饼", updated: "07-28" },
      { no: 55, title: "店门口的约会", updated: "07-24" },
      { no: 54, title: "初春的草莓塔", updated: "07-20" },
    ],
  },
  {
    id: "gushan-jianke",
    title: "孤山剑客",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20lone%20swordsman%20holding%20a%20blade%20on%20a%20misty%20mountain%20peak%20under%20a%20warm%20golden%20sunset%20with%20drifting%20clouds%2C%20wuxia%20fantasy%20manga%20cover%2C%20dramatic%20warm%20lighting%2C%20portrait%20composition&width=600&height=800&seq=cover-gushan-10&orientation=portrait",
    category: "古风",
    tags: ["武侠", "江湖", "热血"],
    score: 9.0,
    chapters: 112,
    status: "连载中",
    views: "187万",
    author: "剑出寒山",
    desc: "孤身一人背负断剑的少年，在乱世江湖中追寻自己的剑道。",
    detail:
      "师父留下一把断剑与一句话后便消失在云海中，少年独自踏入纷乱的江湖。从无名小卒到名动天下的剑客，他一路寻剑、寻人、寻一个答案。作品打斗行云流水，水墨与留白交织，江湖气与少年气并重，是不可错过的武侠诚意之作。",
    updates: "更新至 第112话",
    chapterList: [
      { no: 112, title: "断剑重铸", updated: "今日 03:40" },
      { no: 111, title: "山门外的来客", updated: "昨日 20:30" },
      { no: 110, title: "师父的云海", updated: "08-14" },
      { no: 109, title: "剑名无锋", updated: "08-11" },
      { no: 108, title: "初入江湖", updated: "08-08" },
    ],
  },
  {
    id: "xingchen-youleyuan",
    title: "星尘游乐园",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20whimsical%20amusement%20park%20at%20twilight%20with%20a%20giant%20ferris%20wheel%20among%20glowing%20stardust%20and%20light%20strings%2C%20fantasy%20manga%20cover%2C%20warm%20orange%20and%20gold%20twilight%2C%20portrait%20composition&width=600&height=800&seq=cover-xingchen-11&orientation=portrait",
    category: "奇幻",
    tags: ["游乐园", "冒险", "奇幻"],
    score: 8.9,
    chapters: 69,
    status: "连载中",
    views: "134万",
    author: "摩天轮",
    desc: "只在星光里开园的神秘游乐园，每个项目都是一场冒险。",
    detail:
      "入夜后，城市边缘会亮起一座由星尘构成的游乐园。这里的旋转木马能带你回到过去，鬼屋藏着沉睡的记忆。少年少女们在惊险又浪漫的游乐项目间穿梭，解开乐园背后的谜题。想象力天马行空，画面绚丽，是一趟奇妙的冒险之旅。",
    updates: "更新至 第69话",
    chapterList: [
      { no: 69, title: "最后一枚代币", updated: "今日 02:15" },
      { no: 68, title: "会说话的摩天轮", updated: "昨日 19:50" },
      { no: 67, title: "鬼屋里的记忆", updated: "08-13" },
      { no: 66, title: "旋转木马的回溯", updated: "08-10" },
      { no: 65, title: "开园铃响起", updated: "08-07" },
    ],
  },
  {
    id: "wuye-tushuguan",
    title: "午夜图书馆",
    cover: "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20librarian%20among%20towering%20wooden%20bookshelves%20where%20magical%20books%20glow%20softly%2C%20fantasy%20manga%20cover%2C%20warm%20amber%20candlelight%2C%20cozy%20mysterious%20atmosphere%2C%20portrait%20composition&width=600&height=800&seq=cover-wuye-12&orientation=portrait",
    category: "悬疑",
    tags: ["图书馆", "怪谈", "奇幻"],
    score: 9.1,
    chapters: 84,
    status: "连载中",
    views: "165万",
    author: "纸页声",
    desc: "午夜时分，图书馆里没有读完的书会自己续写故事。",
    detail:
      "城市图书馆的打烊铃声响起后，真正的故事才刚刚开始。管理员能听到书架间的低语，有些书的结局会不断变化，等待某个人来完成。作品悬疑与温情交织，每一章都围绕一本「活过来」的书展开，设定精巧，氛围感十足。",
    updates: "更新至 第84话",
    chapterList: [
      { no: 84, title: "写不完的结局", updated: "今日 01:00" },
      { no: 83, title: "借书卡的秘密", updated: "昨日 22:20" },
      { no: 82, title: "会改写的书", updated: "08-15" },
      { no: 81, title: "书架间的低语", updated: "08-12" },
      { no: 80, title: "夜班管理员", updated: "08-09" },
    ],
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Wide%20anime%20illustration%20of%20a%20vibrant%20cartoon%20city%20skyline%20at%20sunset%20with%20floating%20comic%20pages%20and%20speech%20bubbles%2C%20warm%20orange%20coral%20and%20cream%20color%20palette%2C%20playful%20manga%20collage%20style%2C%20high%20detail%2C%20cheerful%20energetic%20mood&width=1600&height=900&seq=hero-main-01&orientation=landscape";

export const ctaImage =
  "https://readdy.ai/api/search-image?query=Wide%20anime%20illustration%20of%20a%20stack%20of%20glowing%20open%20comic%20books%20with%20stardust%20rising%20under%20a%20warm%20golden%20light%2C%20playful%20manga%20style%2C%20warm%20orange%20and%20cream%20palette%2C%20inviting%20cheerful%20mood&width=1600&height=640&seq=cta-banner-01&orientation=landscape";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20diverse%20group%20of%20young%20editors%20sitting%20together%20reading%20and%20sharing%20comic%20books%20in%20a%20cozy%20studio%20full%20of%20books%20and%20warm%20lamplight%2C%20friendly%20teamwork%20manga%20style%2C%20warm%20orange%20cream%20palette%2C%20portrait%20composition&width=900&height=700&seq=about-team-01&orientation=portrait";